import React, { useContext } from "react";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { cepMask, ufMask } from "../../../services/Masks";
import { validateCep } from "../../../services/MasksValidations";
import { unmaskToNumbers } from "../../../services/Unmasks";
import { Input } from "../../Input";
import MockupCatalogo from "../../Mockups/MockupCatalogo/MockupCatalogo";
import Titulo from "../../Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo";
import { EnderecoContainer } from "./styles";
import Swal from "sweetalert2";

interface EnderecoProps {
  configIn: "empresa" | "configuracoes";
}

const Endereco: React.FC<EnderecoProps> = ({ configIn }) => {
  const { configuracoes, setConfiguracoes } = useContext(ConfiguracoesContext);

  const { theme } = useTheme();

  const handleInputChange = (newValue: string, name?: string) => {
    setConfiguracoes({
      ...configuracoes,
      dados_empresa: {
        ...configuracoes.dados_empresa,
        endereco: {
          ...configuracoes.dados_empresa.endereco,
          [name!]: newValue,
        },
      },
    });
  };

  return (
    <>
      <EnderecoContainer configIn={configIn} theme={theme}>
        <div className="Endereco">
          <div className="informacoes">
            <Titulo
              titulo="Endereço"
              subtitulo="Sua empresa"
              justifyContent="flex-start"
              padding="0"
            />
            <div className="inputs-container">
              <div className="input-container">
                <span className="cep">
                  <Input
                    allowEmojis={false}
                    mask={{
                      mask: cepMask,
                      maskValidation: validateCep,
                      unmask: unmaskToNumbers,
                    }}
                    onChange={handleInputChange}
                    type={"text"}
                    name="cep"
                    value={configuracoes.dados_empresa.endereco.cep}
                    placeholder={"CEP"}
                    error={""}
                    required={true}
                  ></Input>
                </span>
                <span className="estado">
                  <Input
                    allowEmojis={false}
                    minLength={2}
                    maxLength={2}
                    showMaxLength={false}
                    onChange={handleInputChange}
                    mask={{
                      mask: ufMask
                    }}
                    name="estado"
                    type={"text"}
                    value={configuracoes.dados_empresa.endereco.estado.toUpperCase()}
                    placeholder={"Estado"}
                    required={true}
                  ></Input>
                </span>
              </div>
              <div className="input-container">
                <Input
                  allowEmojis={false}
                  onChange={handleInputChange}
                  type={"text"}
                  name="cidade"
                  value={configuracoes.dados_empresa.endereco.cidade}
                  placeholder={"Cidade"}
                  error={""}
                  required={true}
                  maxLength={30}
                  showMaxLength={false}
                ></Input>
              </div>
              <div className="input-container">
                <Input
                  allowEmojis={false}
                  onChange={handleInputChange}
                  type={"text"}
                  name="endereco"
                  value={configuracoes.dados_empresa.endereco.endereco}
                  placeholder={"Endereço"}
                  error={""}
                  required={true}
                  maxLength={100}
                  showMaxLength={false}
                ></Input>
              </div>
              <div className="input-container">
                <div className="numero">
                  <Input
                    allowEmojis={false}
                    onChange={handleInputChange}
                    type={"text"}
                    name="numero"
                    value={configuracoes.dados_empresa.endereco.numero}
                    placeholder={"Número"}
                    error={""}
                    required={true}
                    maxLength={6}
                    showMaxLength={false}
                  ></Input>
                </div>
                <div className="bairro">
                  <Input
                    allowEmojis={false}
                    onChange={handleInputChange}
                    type={"text"}
                    name="bairro"
                    value={configuracoes.dados_empresa.endereco.bairro}
                    placeholder={"Bairro"}
                    error={""}
                    required={true}
                    maxLength={50}
                    showMaxLength={false}
                  ></Input>
                </div>
              </div>
              <div className="input-container">
                <Input
                  allowEmojis={false}
                  onChange={handleInputChange}
                  type={"text"}
                  name="complemento"
                  value={configuracoes.dados_empresa.endereco.complemento}
                  placeholder={"Complemento"}
                  error={""}
                  maxLength={70}
                  showMaxLength={false}
                ></Input>
              </div>
              <div className="checkbox-container">
              <input
                type="checkbox"
                checked={configuracoes.dados_empresa.endereco.ocultar_endereco_catalogo}
                id="ocultarEndereco"
                onChange={async (event) => {
                  const novoValor = event.target.checked;
                  let secondsLeft = 5;
                  if (novoValor) {
                    const result = await Swal.fire({
                      icon: "warning",
                      title: "Atenção",
                      html: `Exibir o endereço é uma exigência legal conforme o Decreto nº 7.962/2013 <a href="https://www.planalto.gov.br/ccivil_03/_ato2011-2014/2013/decreto/d7962.htm" target="_blank" style="text-decoration: underline;">
                        <b>(clique aqui para acessar)</b></a>.
                      Caso prefira ocultar essa informação, esteja ciente dos possíveis riscos.
                    `,
                      showCancelButton: true,
                      confirmButtonText: "Ocultar",
                      cancelButtonText: "Cancelar",
                      customClass: {
                        confirmButton: "btn-confirm2",
                        popup: "custom-swal-popup",
                        icon: "custom-swal-icon",
                        title: "custom-swal-title",
                      },
                      didOpen: () => {
                        const confirmButton = Swal.getConfirmButton();
                        if (confirmButton) {
                          confirmButton.disabled = true;
                          const timerInterval = setInterval(() => {
                            secondsLeft--;
                            confirmButton.innerText = `Ocultar (${secondsLeft})`;
                            if (secondsLeft <= 0) {
                              confirmButton.disabled = false;
                              confirmButton.innerText = "Sim, ocultar";
                              clearInterval(timerInterval);
                            }
                          }, 1000);
                        }
                      },
                    });

                    if (!result.isConfirmed) return;
                  }

                  setConfiguracoes({
                    ...configuracoes,
                    dados_empresa: {
                      ...configuracoes.dados_empresa,
                      endereco: {
                        ...configuracoes.dados_empresa.endereco,
                        ocultar_endereco_catalogo: novoValor,
                      },
                    },
                  });
                }}
              />
              <label className="fonteRotulos" htmlFor="ocultarEndereco">
                Ocultar endereço do catálogo
              </label>
            </div>

            </div>
          </div>
          <div className="mockup-container">
            <MockupCatalogo
              configuracoes={configuracoes}
            />
          </div>
        </div>
      </EnderecoContainer>
    </>
  );
};

export default Endereco;
